import { FC } from "react"
import Icon from "./Icon"
import classNames from "classnames"

type Props = {
  className?: string
}

const PageLoader: FC<Props> = ({ className }) => {
  return (
    <div className={classNames("pageLoader__wrapper", className)}>
      <div className="pageLoader__container">
        <Icon name="spinner" size={40}/>
      </div>
    </div>
  )
}

export default PageLoader
